const adultImageNames = [
  'aika_20323_Sergio Palao.png',
  'aikuinen_19359_Sergio Palao.png',
  'alkoholi_39070_Sergio Palao.png',
  'auto_11631_Annakaisa Ojanen.png',
  'avaimet_21895_Sergio Palao.png',
  'banaani_19607_Sergio Palao.png',
  'bussi_37155_Sergio Palao.png',
  'euro_18980_Sergio Palao.png',
  'haarukka_21235_Sergio Palao.png',
  'ikkuna_24516_Sergio Palao.png',
  'jalka_21971_Sergio Palao.png',
  'jogurtti_4503_Paxtoncrafts Charitable Trust.png',
  'juna_24292_Sergio Palao.png',
  'juusto_4445_Paxtoncrafts Charitable Trust.png',
  'järvi_38565_Elena Chebannaia.png',
  'kahvi_4662_Paxtoncrafts Charitable Trust.png',
  'kala_38883_Sergio Palao.png',
  'kananmuna_21579.png_Sergio Palao.png',
  'kana_20224_Sergio Palao.png',
  'kanelipulla_37875.png_Sergio Palao.png',
  'kastike_34835.png_Paxtoncrafts Charitable Trust.png',
  'kauppa_35186_Paxtoncrafts Charitable Trust.png',
  'kauraleipä_42882_Noel Johansson Ammattiopisto Spesia.png',
  'kenkä_1396_Paxtoncrafts Charitable Trust.png',
  'kevyt_22007_Sergio Palao.png',
  'kirjasto_26462_Sergio Palao.png',
  'kirja_19834_Sergio Palao.png',
  'kirkko_31712_Sergio Palao.png',
  'korva_20888_Sergio Palao.png',
  'kuitti_33522_Sergio Palao.png',
  'kurkku_4857_Paxtoncrafts Charitable Trust.png',
  'kuukausi_3748_Elina Vanninen.png',
  'kuulokkeet_21598_Sergio Palao.png',
  'käsi_21551.png_Sergio Palao.png',
  'lahja_21350_Sergio Palao.png',
  'lanka_32270_Sergio Palao.png',
  'lapsi_28739_Sergio Palao.png',
  'laukku_19579_Sergio Palao.png',
  'lautanen_22686_Sergio Palao.png',
  'leikkele_19295_Sergio Palao.png',
  'leipä_19103_Sergio Palao.png',
  'liha_22141_Sergio Palao.png',
  'lintu_11557_Elina Vanninen.png',
  'lompakko_24428_Sergio Palao.png',
  'lusikka_21909_Sergio Palao.png',
  'lyhyt_35184_Paxtoncrafts Charitable Trust.png',
  'maito_22183_Sergio Palao.png',
  'mehu_34248_Paxtoncrafts Charitable Trust.png',
  'metsä_39487_Susanna Juuti.png',
  'mies_20531_Sergio Palao.png',
  'murot_20159.png_Sergio Palao.png',
  'nainen_20532_Sergio Palao.png',
  'nenä_22385_Sergio Palao.png',
  'nuori_3548_Elina Vanninen.png',
  'omena_19440_Sergio Palao.png',
  'ovi_20781_Sergio Palao.png',
  'painava_26773_Sergio Palao.png',
  'pankki_26434_Sergio Palao.png',
  'paprika_22592_Sergio Palao.png',
  'pasta_4238_Elina Vanninen.png',
  'perhe_11754_Elina Vanninen.png',
  'pieni_23265_Sergio Palao.png',
  'pitkä_34683_Paxtoncrafts Charitable Trust.png',
  'polkupyörä_19721_Sergio Palao.png',
  'polku_37266_Sergio Palao.png',
  'postitoimisto_26474_Sergio Palao.png',
  'puhelin_22209_Sergio Palao.png',
  'pää_21595_Sergio Palao.png',
  'pöytä_31982.png_Ideogrammi  Sari Kivimäki.png',
  'raha_35298.png_Paxtoncrafts Charitable Trust.png',
  'rasva_19981.png_Sergio Palao.png',
  'reppu_23010.png_Sergio Palao.png',
  'riisi_22954.png_Sergio Palao.png',
  'rintakehä_19895.png_Sergio Palao.png',
  'ruisleipä_32569.png_Sergio Palao.png',
  'ruoka_11877.png_Annakaisa Ojanen.png',
  'saari_21843.png_Sergio Palao.png',
  'sairaala_37134.png_Sergio Palao.png',
  'sakset_23090.png_Sergio Palao.png',
  'sandaali_36144.png_Sergio Palao.png',
  'sanomalehti_30382.png_Sergio Palao.png',
  'sanomalehti_5541.png_Sergio Palao.png',
  'sateenvarjo_11902.png_Annakaisa Ojanen.png',
  'silmä_21026.png_Sergio Palao.png',
  'sohva_6559.png_Elina Vanninen.png',
  'sokeri_23440.png_Sergio Palao.png',
  'sormi_21119.png_Sergio Palao.png',
  'suola_23045.png_Sergio Palao.png',
  'suomi_32952.png_Paxtoncrafts Charitable Trust.png',
  'suuri_19724.png_Sergio Palao.png',
  'suu_22268.png_Sergio Palao.png',
  'sänky_19684.png_Sergio Palao.png',
  'taksi_11633.png_Elina Vanninen.png',
  'talo_12033.png_Elina Vanninen.png',
  'tee_4612.png_Elina Vanninen.png',
  'tomaatti_4883.png_Paxtoncrafts Charitable Trust.png',
  'tuli_21131.png_Sergio Palao.png',
  'tuoli_6556.png_Elina Vanninen.png',
  'työ_20946.png_Sergio Palao.png',
  'vanha_12177.png_Elina Vanninen.png',
  'vatsa_19710.png_Sergio Palao.png',
  'veitsi_21914.png_Sergio Palao.png',
  'vesi_24449.png_Sergio Palao.png',
  'viikko_26731.png_Sergio Palao.png',
  'vuosi_24570.png_Sergio Palao.png',
  'ystävä_21268.png_Sergio Palao.png',
];

const kidImageNames = [
  'aamu_1_Sergio_Palao.png',
  'ali_1_Sergio_Palao.png',
  'aurinko_1_Sergio_Palao.png',
  'auto_1_Paxtoncrafts_Charitable_Trust.png',
  'banaani_1_Sergio_Palao.png',
  'hanskat_1_Sergio_Palao.png',
  'hattu_1_Sergio_Palao.png',
  'hevonen_1_Paxtoncrafts_Charitable_Trust.png',
  'housut_1_Paxtoncrafts_Charitable_Trust.png',
  'ilta_1_Sergio_Palao.png',
  'isä_1_Sergio_Palao.png',
  'jalka_1_Paxtoncrafts_Charitable_Trust.png',
  'juna_1_Paxtoncrafts_Charitable_Trust.png',
  'kaakao_1_Sergio_Palao.png',
  'kakku_1_Paxtoncrafts_Charitable_Trust.png',
  'kala_1_Sergio_Palao.png',
  'kana_1_Sergio_Palao.png',
  'karkki_1_Sergio_Palao.png',
  'keksi_1_Paxtoncrafts_Charitable_Trust.png',
  'keltainen_1_Sergio_Palao.png',
  'kenkä_1_Sergio_Palao.png',
  'kesä_1_Susanna_Juuti.png',
  'kevät_1_Elina_Vanninen.jpg',
  'kissa_1_Sergio_Palao.png',
  'kivi_1_Sergio_Palao.png',
  'koira_1_Sergio_Palao.png',
  'korva_1_Sergio_Palao.png',
  'koti_1_Toisto__Tuija_Helkiö.png',
  'koulu_1_Sergio_Palao.png',
  'kuuma_1_Sergio_Palao.png',
  'kylmä_1_Sergio_Palao.png',
  'kynä_1_Sergio_Palao.png',
  'käsi_1_Sergio_Palao.png',
  'laiva_1_Sergio_Palao.png',
  'lammas_1_Sergio_Palao.png',
  'lapsi_1_Sergio_Palao.png',
  'lehmä_1_Sergio_Palao.png',
  'lehti_1_Paxtoncrafts_Charitable_Trust.png',
  'leikkipuisto_1_Sergio_Palao.png',
  'leipä_1_Sergio_Palao.png',
  'lelu_1_Paxtoncrafts_Charitable_Trust.png',
  'limsa_1_Sergio_Palao.png',
  'lintu_1_Paxtoncrafts_Charitable_Trust.png',
  'maito_1_Sergio_Palao.png',
  'matto_1_Sergio_Palao.png',
  'mehu_1_Sergio_Palao.png',
  'minä_1_Sergio_Palao.png',
  'mopo_1_Paxtoncrafts_Charitable_Trust.png',
  'murot_1_Sergio_Palao.png',
  'musta_1_Sergio_Palao.png',
  'nalle_1_Sergio_Palao.png',
  'nenä_1_Sergio_Palao.png',
  'oikea_1_Sergio_Palao.png',
  'opettaja_1_Sergio_Palao.png',
  'paita_1_Paxtoncrafts_Charitable_Trust.png',
  'pallo_1_Sergio_Palao.png',
  'peili_1_Paxtoncrafts_Charitable_Trust.png',
  'perhe_1_Sergio_Palao.png',
  'piha_1_Elina_Vanninen.jpg',
  'pilvi_1_Sergio_Palao.png',
  'puhelin_1_Sergio_Palao.png',
  'punainen_1_Sergio_Palao.png',
  'puuro_1_Paxtoncrafts_Charitable_Trust.png',
  'puu_1_Sergio_Palao.png',
  'päiväkoti_1_Sergio_Palao.png',
  'päivä_1_Paxtoncrafts_Charitable_Trust.png',
  'pää_1_Sergio_Palao.png',
  'rengas_1_Sergio_Palao.png',
  'reppu_1_Sergio_Palao.png',
  'selkä_1_Paxtoncrafts_Charitable_Trust.png',
  'silmä_1_Sergio_Palao.png',
  'sininen_1_Sergio_Palao.png',
  'sinä_1_Sergio_Palao.png',
  'sisko_1_Sergio_Palao.png',
  'sormi_1_Sergio_Palao.png',
  'sukat_1_Sergio_Palao.png',
  'suu_1_Sergio_Palao.png',
  'syksy_1_Elina_Vanninen.jpg',
  'takki_1_Sergio_Palao.png',
  'talo_1_Paxtoncrafts_Charitable_Trust.png',
  'talvi_1_Sergio_Palao.png',
  'traktori_1_Paxtoncrafts_Charitable_Trust.png',
  'tähti_1_Sergio_Palao.png',
  'valkoinen_1_Sergio_Palao.png',
  'varpaat_1_Sergio_Palao.png',
  'vasen_1_Sergio_Palao.png',
  'vatsa_1_Paxtoncrafts_Charitable_Trust.png',
  'veli_1_Sergio_Palao.png',
  'vesi_1_Sergio_Palao.png',
  'vihreä_1_Sergio_Palao.png',
  'yli_1_Paxtoncrafts_Charitable_Trust.png',
  'ystävä_1_Elina_Vanninen.jpg',
  'yö_1_Sclera.png',
  'äiti_1_Paxtoncrafts_Charitable_Trust.png',
];

export { adultImageNames, kidImageNames };
